import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FaCartPlus, FaList } from "react-icons/fa";
import { LuArrowLeft, LuHome } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const AppBar = () => {
  const { setAppBar, appBar } = useThemeStore((state) => state);
  const navigate = useNavigate();

  useEffect(() => {
    setAppBar({ ...appBar, checkout: false, shopList: false });
  }, []);

  const handleLeading = () => {
    if (appBar.leading === "back") {
      navigate(-1);
    } else {
      navigate(linkPage.HOME_DASHBOARD, { replace: true });
    }
  };

  return (
    <div className="header tw-flex tw-items-center tw-justify-between tw-px-4">
      <div
        className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
        onClick={handleLeading}
      >
        <div className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-xl tw-bg-surface-100">
          {appBar.leading === "home" ? (
            <LuHome size={15} className="tw-text-primary" />
          ) : (
            <LuArrowLeft size={15} className="tw-text-primary" />
          )}
        </div>
        <div className="tw-text-sm tw-font-semibold tw-text-text-primary">
          {appBar.title}
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-2 tw-text-text-primary">
        {(appBar.actions ?? []).map((action) => action)}
        <>
          {appBar.checkout && (
            <div
              className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-xl tw-bg-surface-100 tw-cursor-pointer"
              onClick={() => navigate(linkPage.MARKETPLACE_CHECKOUT)}
            >
              <FaCartPlus size={14} className="tw-text-primary" />
            </div>
          )}
          {appBar.shopList && (
            <div
              className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-xl tw-bg-surface-100 tw-cursor-pointer"
              onClick={() => navigate(linkPage.MARKETPLACE_HISTORY)}
            >
              <FaList size={14} className="tw-text-primary" />
            </div>
          )}
        </>
      </div>
    </div>
  );
};
